import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const KEY = "hr_merch_cart";
const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((item) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.product_id === item.product_id && x.variant_id === item.variant_id);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], quantity: Math.min(25, next[i].quantity + (item.quantity || 1)) };
        return next;
      }
      return [...prev, { ...item, quantity: Math.min(25, item.quantity || 1) }];
    });
    setOpen(true);
  }, []);

  const setQty = useCallback((product_id, variant_id, quantity) => {
    setItems((prev) => prev.map((x) => (x.product_id === product_id && x.variant_id === variant_id ? { ...x, quantity: Math.max(1, Math.min(25, quantity)) } : x)));
  }, []);

  const remove = useCallback((product_id, variant_id) => {
    setItems((prev) => prev.filter((x) => !(x.product_id === product_id && x.variant_id === variant_id)));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((n, x) => n + x.quantity, 0);
  const subtotal = items.reduce((n, x) => n + (x.price || 0) * x.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, count, subtotal, open, setOpen, add, setQty, remove, clear }}>
      {children}
    </CartCtx.Provider>
  );
}
